 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import STRIBLINGLADYBEANPRELIMSALL_IN_ONE_WITHOUT_HLINKS_ from '@/components/STRIBLING-Lady-Bean-Prelims-all_in_one_-without_H--links_'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/STRIBLING-Lady-Bean-Prelims-all_in_one_-without_H--links_",
 			"name" : "STRIBLING-Lady-Bean-Prelims-all_in_one_-without_H--links_",
 			"component" : STRIBLINGLADYBEANPRELIMSALL_IN_ONE_WITHOUT_HLINKS_
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js